<template>
  <div>
    <van-field
      readonly
      clickable
      :label="label"
      class="term"
      v-model="value"
      :placeholder="placeholder"
      right-icon="arrow"
      @click="showTermPicker = true"
    />
    <van-popup
      v-model="showTermPicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="columnsTerm"
        @cancel="showTermPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <div class="term2">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelfSelect',
  props: {
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    defaultValue: {
      default: '',
    },
    columnsTerm: {
      type: Array,
    },
  },
  data() {
    return {
      showTermPicker: false,
      value: '',
    };
  },

  methods: {
    onConfirm(val) {
      // 个别选择器选择后需要上送给后台的值为多个，需要一并传给父组件
      this.$emit('selectValues', val);
      this.$emit('input', val.value);
      this.value = val.text;
      this.showTermPicker = false;
    },
  },
  watch: {
    columnsTerm: {
      handler(val) {
        const filterResult = val.filter((item) => (item.value === this.defaultValue));
        if (filterResult.length === 0) return;
        this.value = filterResult[0].text;
        this.$emit('input', filterResult[0].value);
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
>>> .van-field__label {
  text-align: left;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
  width: 129px !important;
  margin-right: 0px !important;
}
.term::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
>>> .van-picker__cancel,
>>> .van-picker__confirm {
  color: #ff6538;
}
>>> .van-field__control::-webkit-input-placeholder {
  color: #828282;
}

>>> .van-field__control::-moz-input-placeholder {
  color: #828282;
}

>>> .van-field__control::-ms-input-placeholder {
  color: #828282;
}
</style>
